import { lazy } from "react";
import { connect } from "react-redux";
import {
  loading,
  data,
  pagination,
} from "../../../store/administration/selectors/concept_categories";

const ConceptCategories = lazy(() => import("./ConceptCategories"));

const mapStateToProps = (state) => ({
  isLoading: loading(state),
  conceptCategories: data(state),
  pagination: pagination(state),
});

export default connect(mapStateToProps)(ConceptCategories);
